(function ($) {

  // See /about. This disables the accordion behavior on desktops, but enables it on mobile and tablet views
  Drupal.behaviors.noAccordionDesktop = {
    attach: function (context) {
      $('.field--name-dynamic-block-fieldnode-subnav > h3[data-toggle="collapse"]').click(function (e) {
        if ($(window).width() >= 0) {
          e.stopPropagation();
        }
      });
    }
  };

  Drupal.behaviors.matchItemHeight = {
    attach: function (context) {

      $(once('window-load', '.sprout-list-item.node--view-mode-teaser')).each(function () {
          $(function () {
          $('.sprout-list-item.node--view-mode-teaser').matchHeight({
            property: 'min-height',
            byRow: true
          });
        });

      });
      $(once('window-load', '.gridnav--item-wrapper .thumbnail')).each(function () {
        $(function () {
          $('.gridnav--item-wrapper .thumbnail').matchHeight({
            property: 'min-height',
            byRow: true
          });
        });

      });
    }
  };


  Drupal.behaviors.fakeAnchor = {
    attach: function (context) {
      var anchorButton = $('<div class="anchor-container"><button class="anchor">Upcoming Events</button></div>');
      var anchorDestination = $('#paragraph-11');
      var anchorPlacement = $('.path-frontpage .paragraph--type-billboard:first-of-type .bs-region--middle');
      var anchorPlacementMobile = $('.path-frontpage .paragraph--type-billboard:first-of-type .bs-region--middle-first');
      $(anchorButton).click(function (e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(anchorDestination).offset().top
        }, 1000)
      });
      $(once('window-load', anchorButton, context)).each(function () {

        if ($(window).width() <= 767) {
          $(anchorButton).appendTo(anchorPlacementMobile);
        }
        if ($(window).width() >= 768) {
          $(anchorPlacement).after($(anchorButton));
        }
        $(window).on('resize', function () {
          if ($(window).width() <= 767) {
            $('.anchor-container').appendTo(anchorPlacementMobile);
          }
          if ($(window).width() >= 768) {
            $(anchorPlacement).after($('.anchor-container'));
          }
        });
      });
    }
  }

  Drupal.behaviors.fakeAnchorFestival = {
    attach: function (context) {
      var anchorButton = $('<div class="anchor-container"><button class="anchor">Upcoming Events</button></div>');
      var anchorDestination = $('#paragraph-193');
      var anchorPlacement = $('.path-festival .paragraph--type-billboard:first-of-type .bs-region--middle');
      var anchorPlacementMobile = $('.path-festival .paragraph--type-billboard:first-of-type .bs-region--middle-first');
      $(anchorButton).click(function (e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(anchorDestination).offset().top
        }, 1000)
      });
      $(once('window-load', anchorButton, context)).each(function () {

        if ($(window).width() <= 767) {
          $(anchorButton).appendTo(anchorPlacementMobile);
        }
        if ($(window).width() >= 768) {
          $(anchorPlacement).after($(anchorButton));
        }
        $(window).on('resize', function () {
          if ($(window).width() <= 767) {
            $('.anchor-container').appendTo(anchorPlacementMobile);
          }
          if ($(window).width() >= 768) {
            $(anchorPlacement).after($('.anchor-container'));
          }
        });
      });
    }
  }


  Drupal.behaviors.darkNav = {
    attach: function (context) {
      if ($('.page-node-type-landing-page .bs-region--top-first').length) {
        // don't do a thing
      } else {
        $('.page-node-type-landing-page').addClass('dark-nav');
      }
    }
  };

  Drupal.behaviors.hoverMenu = {
    attach: function (context) {
      $('.menu--main button', context).removeAttr('data-toggle');
      if ($(window).width() <= 1199) {
        $(once('hover-menu', '.dropdown-toggle', context)).on('click', function (e) {
          e.preventDefault();
          $(this).parent().toggleClass('open');
          $(this).parent().siblings().removeClass('open');
        });
        $(document).on('click', function(e){
          var menu_opened = $('#navbar-collapse').hasClass('in');

          if(!$(e.target).closest('#navbar-collapse').length &&
              !$(e.target).is('#navbar-collapse') &&
              menu_opened === true){
                  $('#navbar-collapse').collapse('toggle');
          }
        })
      }
      if ($(window).width() >= 1200) {
        $('.menu--main > li.expanded').hover(
          function () {
            $(this).addClass('open');
          },
          function () {
            $(this).removeClass('open');
          }
        );
      }

    }
  };

  Drupal.behaviors.transparentNavColor = {
    attach: function (context) {
      $('.navbar-toggle').on('click', function (e) {
        $('header').toggleClass('bg-color-change');

      })
    }
  };

  Drupal.behaviors.audioPlayer = {
    attach: function (context) {
      $(once('window-loaded', 'body', context)).each(function () {
      $('.play').on('click', function (e) {
        var theButton = $(this);
        // starting audio
        var audioID = $(this).siblings('audio').attr('id');
        var lastAudio = $('.audiofield-player').last().children('audio');
        var lastAudioID = $('.audiofield-player').last().children('audio').attr('id');
        var lastaud = document.getElementById(lastAudioID);
        var playingSibling = $(this).parent('.audiofield-player').siblings().hasClass('active');
        $(theButton).toggleClass('playing');
        $(theButton).parent('.audiofield-player').toggleClass('active');
        if (theButton.hasClass('playing')) {
          $("#" + audioID).trigger('play');
        } else {
          $("#" + audioID).trigger('pause');
        }
        if ($(playingSibling).length) {
          console.log('i have a sibling');
          $('.play').not(this).parents('.audiofield-player').removeClass('active');
          $('.play').not(this).removeClass('playing');
          $('.play').not(this).siblings('audio').trigger('pause');
        }
        console.log(lastAudioID);

        var activeAudio = $('.active audio').attr('id');
        console.log(activeAudio);
        var aud = document.getElementById(activeAudio);
        aud.onended = function () {
          $(this).parent('.audiofield-player').removeClass('active');
          $(theButton).removeClass('playing');
          $(this).parent('.audiofield-player').next('.audiofield-player').addClass('active');
          $(theButton).parent('.audiofield-player').next('.audiofield-player').children('.play').addClass('playing');
          $('.active audio').trigger('play');

        };
        lastaud.onended = function (f) {
          $(this).parent('.audiofield-player').removeClass('active');
          $(this).siblings('button').removeClass('playing');
        };
      });
    });

    }

  };


  // Mitigate IE/Edge bug showing bullets on lists which are hidden when loading the page
  $(document).ready(function () {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      $('ul:hidden').each(function () {
        $(this).parent().append($(this).detach());
      });
    }
  });

  Drupal.behaviors.searchPageTitle = {
    attach: function(context, settings) {
      $(once("searchPageTitle", ".path-search h1"))
        .each(function() {
          var text = $(this).text();
          text = text.replace( /Search for (.*)/gi, 'Search Results for “$1”' );
          $(this)
            .text(text)
            .css({ display: "block" });
            $(this)
            .after('<p class="search-help">Please use the “Search” box at the top of the page to enter a new search keyword.</p>');
        });
    }
  };

  Drupal.behaviors.searchToggleOverlay = {
    attach(context) {
      $(once('search-toggle', '.search-toggle', context)).on(
          'click',
          function () {
            $('body').toggleClass('search--opened');
            $('#block-searchform').toggleClass('show');
          }
      );
    }
  };

  Drupal.behaviors.applicationFee = {
    attach: function(context, settings) {
      if ($('body.path-_022-piano-competition-application-thank-you').length) {
        const urlParams = new URLSearchParams(window.location.search);
        document.getElementById('description').value = 'Piano Competition payment for ' + urlParams.get('name');
        document.getElementById('amount').value = urlParams.get('fee').split('$').pop();
      }
    }
  };


})(jQuery, Drupal, once);
